<template>
  <DxPopup @hidden="onHidden" :visible="showPop" :show-close-button="true" :show-title="true" :title="'View Drawing Page'" height="600px" width="800px">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="'View Drawing Page'" >
          <template v-slot:body>
            <v-layout column >
              <v-row no-gutters style="margin-top: 10px;">
                <v-col cols="12">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-icon small style="color: #2196F3; margin-top: -4px;">mdi-circle</v-icon>
                      <span class="subTitle"> PO No : {{poNo}}</span>
                    </v-col>
                  </v-row>
                  <v-row no-gutters style="margin-top: 10px;">
                    <v-col cols="12">
                      <DxDataGrid id="drawingPage" 
                        class="drawingPage"
                        :height="380"
                        :ref="drawingPageRef"
                        :data-source="gridMainList" 
                        :remote-operations="false" 
                        :hover-state-enabled="true"
                        :allow-column-resizing="true" 
                        :allow-column-reordering="true"
                        :row-alternation-enabled="true" 
                        :show-borders="true" 
                        :width="grid.width"
                        :show-row-lines="true" 
                        key-expr="id" 
                        :focused-row-enabled="true"
                        :column-hiding-enabled="false" 
                        :selection="{ mode: 'none' }"
                        @cellPrepared="cellPrepared"
                      >
                        <DxEditing :use-icons="true" />
                        <DxColumn data-field="porNo" caption="POR No" width="25%" data-type="string" alignment="center" :visible="true" />
                        <DxColumn data-field="revNo" caption="Rev." width="10%" data-type="string" alignment="center" :allow-editing="false" />
                        <DxColumn data-field="seq" caption="No" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                        <DxColumn data-field="sysFileNm" caption="Drawing page" width="45%" data-type="string" alignment="center" :allow-editing="false" cell-template="sysFileNmTemplate" />
                          <template #sysFileNmTemplate="{ data }">
                            <v-btn small elevation="0" color="transparent" class="px-1 py-0 receiptBtn" @click="sysFileNm(data)" >
                              {{data.text}}
                            </v-btn>
                          </template>
                        <DxColumn data-field="fileAddr" caption="fileAddr" width="25%" data-type="string" alignment="center" :allow-editing="false"  :visible="false" />
                        <DxPaging :enabled="false" :page-size="30" />
                      </DxDataGrid>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </DxPopup>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup';
import { DxDataGrid, DxEditing, DxColumn , DxButton } from 'devextreme-vue/data-grid'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import { getDwgListByPO, getDwgListByQuot, getDwgListByPor, getDwgTicket } from '@/api/view/hip/common/common.js'
import customProtocolCheck from "custom-protocol-check";
import {ftpDownload} from "../../../api/view/hip/common/common";

export default {
  name: 'drawingPagePop',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxPopup,
    ICardVertical,
    iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,
  },
  props: {
    showPop: {
      type: Boolean,
      default() {
        return false
      }
    },
    gbn: {
      type: String,
      default() {
        return '' // 'QUOT', 'POR', 'PO'
      }
    },
    paramNo: {
      type: String,
      default() {
        return
      }
    },
  },
  data() {
    return {
      drawingPageRef: 'drawingPageRef',
      gridMainList: [],
      poNo: '',
    }
  },
  mounted(){
    this.doSearchMain()
  },
  methods: {
    onHidden(e) {
      this.$emit('update:showPop', false)
    },
    async doSearchMain(){
      this.openLoading('searching')
      let params = { quotNo: this.paramNo , poNo: '' , porNo: '' } 
      let params2 = { porNo: this.paramNo , quotNo: '',  poNo: ''} 
      let params3 = { poNo: this.paramNo , quotNo: '',porNo: '' } 

      switch(this.gbn) {
        case 'QUOT':
        await getDwgListByQuot(params).then(res => {
            this.gridMainList = res.list
          }).finally(() => {
            this.endLoading()
          })
          break
        case 'POR':
        await getDwgListByPor(params2).then(res => {
        
            this.gridMainList = res.list

          }).finally(() => {
            this.endLoading()
          })
          break
        case 'PO':
          this.poNo = params3.poNo;

          await getDwgListByPO(params3).then(res => {
            this.gridMainList = res.list

          }).finally(() => {
            this.endLoading()
          })
          break
      }
    },
    sysFileNm(e){    


      this.openLoading()
      
      if (e.data.hmdporyn === 'Y')
        {  
          // 뷰어 호출
          
          const param = {
            shipNum: e.data.porNo.substr(0, 4) + '06',
            docNum: e.data.porNo,
            revNum: e.data.revNo,
            gubun: 'P',
            userId: this.$store.state.user.makerCd,
            workCode : 'POR'

          }

        getDwgTicket(param).then(res => {
          let ticket = res.body;
          event.preventDefault ? event.preventDefault() : (event.returnValue = false);

          customProtocolCheck(
              // Custom Protocol
              ('npshmdsecuview://' + ticket),
              // Custom Protocol 이 지원하지 않을 경우
              function() {
                //location.href = "http://s-viewer.hmd.co.kr/Setup/Launcher/eng/NpsLauncherSetup.msi";
                location.href = "https://ibiz.hd-hvs.com/sview/Setup/Launcher/eng/NpsLauncherSetup.msi";
              },
              // Custom Protocol 이 지원할 경우
              function() {
                console.log("supported");
              }
          );
        }).finally(() => {
          this.endLoading()
        })
        }
      else {          
       // window.open(e.data.fileAddr)
       
        var path = e.data.fileAddr;
        // M.Chi modify, POR is created by Design Dept
        if(path.startsWith("/"))
        {
           path = path.replace( "http://ebiz.hvs.com.vn/", "" ).substring(1);
        }

        path = path.replace( "http://ebiz.hvs.com.vn/", "" );
        var tmp = path.split('/');
        var t1 = tmp[tmp.length - 1];
        var fname = t1.split('.');

        this.openLoading()
        console.log('t1', t1)
        ftpDownload(path, fname[0]).then((ret) =>{
            // 
        }).catch(error => {
            this.vToastify('This file is not existed. Please contact HVS Purchaser!')
        })
        .finally(() => {
          this.endLoading()
        })
       

      }  
      this.endLoading()

    },
    cellPrepared(e){
      if(e.rowType === 'data'){
        e.cellElement.style.padding = '1px'
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.subText {
  color: #FF0000;
  font-size: 10pt;
  font-weight: bold;
}
.subTitle {
  font-weight: bold;
  color: black;
  font-size: 12pt;
}
.receiptBtn {
  font-weight: bold;
}
.receiptBtn:hover {
  color: #4980BC;
}


</style>